export function primaryTitle(title?: string | null, titleEn?: string | null) {
  return titleEn?.trim() || title?.trim() || "Untitled project";
}

export function secondaryTitle(title?: string | null, titleEn?: string | null) {
  const chinese = title?.trim() || "";
  return titleEn?.trim() && chinese ? chinese : "";
}
